// ContextScoreView._mock.ts
// Types and config for ContextScoreView

export const API_TO_CTX_CAT: Record<string, string> = {
  natural_hazards: "NATURAL_HAZARDS",
  health_quality: "HEALTH_QUALITY",
  safety: "SAFETY",
  location: "LOCATION",
  amenities: "AMENITIES",
  site: "SITE",
};

export const CTX_CATEGORY_LABELS: Record<string, string> = {
  NATURAL_HAZARDS: 'Hazards',
  HEALTH_QUALITY: 'Health',
  SAFETY: 'Safety',
  LOCATION: 'Access',
  AMENITIES: 'Amenities',
  SITE: 'Parcel',
};
